import React, { useEffect, lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Header from "./Components/Header/Header";
import Footer from "./Components/Footer/Footer";
import ErrorBoundary from "./Components/Common/ErrorBoundary";
import PageLoader from "./Components/Common/PageLoader";

// Lazy-loaded route components for optimal initial bundle & performance
const ArticleSection = lazy(() => import("./Components/ArticleSection/ArticleSection"));
const About = lazy(() => import("./Components/About/About"));
const Products = lazy(() => import("./Components/Products/Products"));
const Quarries = lazy(() => import("./Components/Quarries/Quarries"));
const Services = lazy(() => import("./Components/Services/Services"));
const Contact = lazy(() => import("./Components/Contact/Contact"));
const PrivacyPolicy = lazy(() => import("./Components/Privacy/PrivacyPolicy"));
const NotFound = lazy(() => import("./Components/NotFound/NotFound"));

// Helper component to scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <ScrollToTop />
        <a href="#article-details" className="skip-link">
          Skip to main content
        </a>

        <div className="app-main-wrapper">
          <Header />
          <main id="main-content">
            <Suspense fallback={<PageLoader />}>
              <Routes>
                <Route path="/" element={<ArticleSection />} />
                <Route path="/about" element={<About />} />
                <Route path="/products" element={<Products />} />
                <Route path="/quarries" element={<Quarries />} />
                <Route path="/services" element={<Services />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Suspense>
          </main>
          <Footer />
        </div>
      </Router>
    </ErrorBoundary>
  );
}

export default App;